import { schema } from "normalizr";
import { frameSchema } from "../frame";
import { assessmentAnswerSchema } from "../assessmentAnswer";

export const revisionSchema = new schema.Entity("revisions", {
  frames: [frameSchema],
  assessmentAnswers: [assessmentAnswerSchema]
});
